export const BLASTS_SECTION = 'blasts'
export const CONVERSATIONS_SECTION = 'conversations'
export const NEWSLETTERS_SECTION = 'newsletters'
